import React from 'react';
import { reduxWrapper } from '@common/redux/store';
import { Museums } from "@kursk/components/pages/Museums/Museums";
import { loadEntitiesFromQuery } from "@kursk/utils/loadEntitiesFromQuery";

export default function MuseumsPage() {
  return <Museums/>;
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, query }) => {
  await Promise.all([
    loadEntitiesFromQuery('museums', query, store),
  ]);

  return { props: {} };
})
